// modules
import { setUploadToken } from '@weblite/file'

import { connect } from '$setup/ws'
import { setTwaAuthToken } from '$logic/twaCommunication'
import { getClientUserIdentityToken } from '$logic/auth'
import { removeSignOutByServerAnalyticsEvent } from '$logic/auth/sign-out-analytics'
import { handleUrlToLoadAfterLogin } from '$logic/router'

const afterSignIn = () => {
  connect()
  getClientUserIdentityToken().then(setUploadToken)
  setTwaAuthToken()
  removeSignOutByServerAnalyticsEvent()

  handleUrlToLoadAfterLogin()
}

export default afterSignIn
